import React from 'react';
import PropTypes from 'prop-types';
import Tab from '@spothero/ui/tab';
import TabContent from '@spothero/ui/tab-content';
import TabNavigation from '@spothero/ui/tab-navigation';
import TabPanel from '@spothero/ui/tab-panel';
import Tabs from '@spothero/ui/tabs';
import AmenitiesFilters from './AmenitiesFilters';
import AvailabilityFilters from './AvailabilityFilters';

const MonthlyFilters = ({
    amenities,
    activeAmenities,
    activeReservationType,
    reservationTypes,
    onAmenityChange,
    onReservationTypeChange,
}) => {
    return (
        <Tabs className="MonthlyFilters">
            <TabNavigation>
                <Tab label="Availability">Availability</Tab>
                <Tab label="Amenities">Amenities</Tab>
            </TabNavigation>
            <TabContent>
                <TabPanel>
                    <AvailabilityFilters
                        activeReservationType={activeReservationType}
                        reservationTypes={reservationTypes}
                        onChange={onReservationTypeChange}
                    />
                </TabPanel>
                <TabPanel className="AmenitiesFilterPanel">
                    <AmenitiesFilters
                        amenities={amenities}
                        activeAmenities={activeAmenities}
                        onChange={onAmenityChange}
                    />
                </TabPanel>
            </TabContent>
        </Tabs>
    );
};

MonthlyFilters.propTypes = {
    amenities: PropTypes.object.isRequired,
    activeAmenities: PropTypes.array.isRequired,
    activeReservationType: PropTypes.string.isRequired,
    reservationTypes: PropTypes.object.isRequired,
    onAmenityChange: PropTypes.func.isRequired,
    onReservationTypeChange: PropTypes.func.isRequired,
};

export default MonthlyFilters;
